import {createContext} from 'react';

import type {TabsContextProps} from './TabsContextProps';

export default createContext<TabsContextProps | undefined>(undefined);
